import { createRoute, useParams } from '@tanstack/react-router';
import { IconAdjustmentsHorizontal, IconBuilding, IconHistory, IconPlug, IconServer, IconShield, IconWorld } from '@tabler/icons-react';
import type { NavItem, Zone } from '@hana/shell';
import { AdminHome } from './admin/AdminHome';
import { ActionLog } from './actionlog/ActionLog';
import { Roles } from './roles/Roles';
import { WebAdmin } from './webadmin/WebAdmin';
import { M365Page } from './integrations/M365Page';
import { ZaloOAPage } from './integrations/ZaloOAPage';

// Vùng HANA Kit (/kit): quản trị hệ thống, chỉ ghế ADMIN (QĐ anh David 01/Nov, canvas duyệt 14:43 — luồng O, issue 652).
// Thuộc PWA Hub (phạm vi `/`): KHÔNG có manifest riêng. Menu theo NAVK.sp.kit của board Mint-Admin: NGƯỜI DÙNG · CẤU HÌNH · VẬN HÀNH.
// Mint-Admin là trang gốc (/kit, không nút ←); mục con của Mint-Admin ở /kit/<view>; board riêng ở /kit/roles · m365 · zalo-oa · action-log · web-admin.

export { isKitAdmin, kitAccess, KIT_ADMINS, viewerCode } from './access';
export { kitRedirect, LEGACY } from './legacy';

const it = (key: string, label: string, to: string): NavItem => ({ key, label, to });

export const zone: Zone = {
  key: 'kit',
  name: 'HANA Kit',
  top: [],
  nav: [
    { key: 'kq', label: 'Người dùng & quyền', icon: IconShield, section: 'NGƯỜI DÙNG', items: [it('users', 'Người dùng & quyền', '/kit/users'), it('roles', 'Hồ sơ vai trò', '/kit/roles'), it('perm', 'Phân quyền theo form', '/kit/perm'), it('seats', 'Sơ đồ ghế & phòng', '/kit/seats'), it('approve', 'Ma trận duyệt & ký', '/kit/approve')] },
    { key: 'cty', label: 'Công ty & giờ làm việc', icon: IconBuilding, items: [it('company', 'Thông tin công ty', '/kit/company'), it('workcal', 'Giờ làm việc & lễ', '/kit/workcal')] },
    { key: 'ts', label: 'Tham số & quy tắc', icon: IconAdjustmentsHorizontal, section: 'CẤU HÌNH', items: [it('params', 'Trung tâm tham số & quy tắc', '/kit'), it('flags', 'Cờ tính năng', '/kit/flags'), it('queue', 'Hàng chờ thay đổi', '/kit/queue'), it('inbox', 'Duyệt tập trung', '/kit/inbox')] },
    { key: 'tic', label: 'Tích hợp', icon: IconPlug, items: [it('m365', 'M365', '/kit/m365'), it('zalo-oa', 'Zalo OA', '/kit/zalo-oa'), it('ai', 'Ask HANA & OCR', '/kit/ai')] },
    { key: 'ht', label: 'Hệ thống', icon: IconServer, section: 'VẬN HÀNH', items: [it('subs', 'Tài khoản hệ thống & gia hạn', '/kit/subs'), it('syscost', 'Chi phí hệ thống', '/kit/syscost'), it('jobs', 'Giám sát tác vụ nền', '/kit/jobs'), it('repair', 'Dọn dữ liệu & bảo trì', '/kit/repair'), it('imports', 'Lịch sử import', '/kit/imports')] },
    { key: 'nk', label: 'Nhật ký & góp ý', icon: IconHistory, items: [it('action-log', 'Nhật ký thao tác', '/kit/action-log'), it('feedback', 'Góp ý người dùng', '/kit/feedback')] },
    { key: 'web', label: 'Website', icon: IconWorld, items: [it('web-admin', 'Quản trị website', '/kit/web-admin')] },
  ],
  routes: (parent) => [
    createRoute({ getParentRoute: () => parent, path: '/', component: () => <AdminHome /> }),
    createRoute({ getParentRoute: () => parent, path: 'roles', component: Roles }),
    createRoute({ getParentRoute: () => parent, path: 'action-log', component: ActionLog }),
    createRoute({ getParentRoute: () => parent, path: 'web-admin', component: WebAdmin }),
    createRoute({ getParentRoute: () => parent, path: 'm365', component: M365Page }),
    createRoute({ getParentRoute: () => parent, path: 'zalo-oa', component: ZaloOAPage }),
    createRoute({ getParentRoute: () => parent, path: '$view', component: AdminView }),
  ],
};

/** Mục con của Mint-Admin (/kit/<view>): `seats` → view `g:seats` của board. */
function AdminView() {
  const view = (useParams({ strict: false }) as { view?: string }).view ?? 'params';
  const G = ['company', 'seats', 'workcal', 'ai', 'payroll', 'attend', 'kpi', 'sla', 'margin', 'trucktariff', 'tpl', 'mailtpl', 'integ', 'master', 'units', 'backup'];
  return <AdminHome view={G.includes(view) ? `g:${view}` : view} />;
}
